import { useDispatch, useSelector } from 'react-redux'

import { Brand } from '../model'
import { changeBrand } from '../store/brand.reducer'
import { selectBrand } from '../store/brand.selectors'

interface useBrand {
  setBrand: (brand: Brand) => void
  brand: Brand
}

function useBrand(): useBrand {
  const dispatch = useDispatch()
  const brand = useSelector(selectBrand)

  function setBrand(newBrand: Brand): void {
    dispatch(changeBrand(newBrand))
  }

  return {
    setBrand,
    brand,
  }
}

export default useBrand
